export var normalizeUrl = function (url) { return url.replace(/([a-z\-_0-9]+)\/\//gi, '$1/'); };
//# sourceMappingURL=normalize-url.js.map